import PropTypes from 'prop-types'

import { MenuItem, Typography } from '@mui/material'

import useTranslations from '../../../../i18n/useTranslations'
import Select from '../../../../ui/components/select'
import { getFieldProps } from '../../../../common/formProps'

const ClientCenterCode = ({
  centers,
  values,
  fieldErrors,
  touched,
  handleChange,
}) => {
  const t = useTranslations()
  return (
    <Select
      labelId="clientCenterCode"
      id="clientCenterCode"
      label={
        <Typography variant="h4bold">{t('noun:clientCenterCode')}</Typography>
      }
      name="clientCenterCode"
      {...getFieldProps('clientCenterCode', values, fieldErrors, touched, t)}
      className="full-width"
      onChange={e => {
        handleChange({
          target: { name: 'clientCenterCode', value: e.target.value },
        })
      }}
    >
      {centers
        ? centers.map((clientCenter, idx) => (
            <MenuItem key={clientCenter.id} value={`${clientCenter.hideId}`}>
              {clientCenter.id} | {clientCenter.name}
            </MenuItem>
          ))
        : null}
    </Select>
  )
}
ClientCenterCode.propTypes = {
  centers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  values: PropTypes.shape({
    clientCenterCode: PropTypes.string.isRequired,
  }),
  fieldErrors: PropTypes.shape({
    clientCenterCode: PropTypes.string.isRequired,
  }),
  touched: PropTypes.shape({
    clientCenterCode: PropTypes.string,
  }),
  handleChange: PropTypes.func.isRequired,
}

export default ClientCenterCode
